import React from 'react';
import Chat from '@material-ui/icons/Chat';
import styled from 'styled-components';
import DriveEta from '@material-ui/icons/DriveEta';
import Edit from '@material-ui/icons/Edit';
import Assessment from '@material-ui/icons/Assessment'
import Help from '@material-ui/icons/Help'

export const PvTheoryIcon = styled(Chat)`
  color: ${props => props.theme.colors.berryRed};
  font-size: 28px;
`;

export const PvDrivingIcon = styled(DriveEta)`
  color: ${props => props.theme.colors.green};
  font-size: 28px;
`;

export const PvTrainingIcon = styled(Assessment)`
  color: ${props => props.theme.colors.green};
  font-size: 28px;
`;

export const PvUnknownIcon = styled(Help)`
  color: ${props => props.theme.colors.black};
  font-size: 28px;
`;

export const PvEditIcon = styled(Edit)`
  color: ${props => props.theme.colors.green};
  cursor: pointer;
  font-size: 28px;
  transition: color .2s ease !important;
  &:hover {
    color: ${props => props.theme.colors.grays[0]};
  }
`;

export const LessonTypeIcon = (props) => {
  const type = props.type || "";
  if (~type.indexOf('THEORY'))
    return <PvTheoryIcon {...props} />;
  else if (~type.indexOf('DRIVING'))
    return <PvDrivingIcon {...props} />;
  else if (~type.indexOf('TRAINING'))
    return <PvTrainingIcon {...props} />;
  else
    return <PvUnknownIcon {...props} />;
};



// WEBPACK FOOTER //
// ./src/util/IconUtil.js